import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";

/**
 * Top-level crash guard for the admin panel. Ported from
 * products/x2mail-admin/src/components/ErrorBoundary.tsx (absorbed into this
 * panel per PK's single-panel consolidation directive, 2026-07-15) — no
 * equivalent existed here before.
 */
export interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  message: string;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return {
      hasError: true,
      message: error instanceof Error ? error.message : String(error),
    };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[voice2mail-admin] Uncaught error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-slate-50 p-8">
          <div className="max-w-md rounded-lg border border-red-200 bg-red-50 p-6">
            <h2 className="mb-2 text-lg font-semibold text-red-700">Nieoczekiwany błąd</h2>
            <p className="text-sm text-slate-600">{this.state.message}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
